import styled, { css } from 'styled-components'
import { motion } from 'framer-motion'

import { color } from 'src/styles/colors'
import { fontWeight, fontSize } from 'src/styles/fonts'
import { ActionAnswer } from 'src/api/quizzes/types'

export const Wrap = styled(motion.div)<{ emotion?: ActionAnswer }>`
  position: absolute;
  ${({ emotion }) => {
    if (emotion === ActionAnswer.up)
      return css`
        top: 10rem;
        left: 50%;
        transform: translate(-50%, 0);
      `
    if (emotion === ActionAnswer.down)
      return css`
        bottom: 10rem;
        left: 50%;
        transform: translate(-50%, 0);
      `
    if (emotion === ActionAnswer.left)
      return css`
        top: 50%;
        transform: translate(0, -50%);
        left: 10rem;
      `
    if (emotion === ActionAnswer.right)
      return css`
        top: 50%;
        transform: translate(0, -50%);
        right: 10rem;
      `
    if (emotion === ActionAnswer.skip)
      return css`
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      `
    return ``
  }}
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const Label = styled.span`
  border-radius: 1.6rem;
  line-height: 3.2rem;
  background-color: rgba(0, 0, 0, 0.08);
  color: ${color.WHITE};
  font-weight: ${fontWeight.ULTRA};
  font-size: ${fontSize.LARGE_XL};
  padding: 0 1.6rem;
  margin-top: 0.8rem;
`
